import { PaymentAttribution } from 'core/enums/payment-type';
import { MakePaymentPayloadDTO } from 'core/models/account/make-payment-payload.dto';
import { PaymentRequestRedirectResponse } from 'core/services/api/payment/payment-dpp';
import { PayAtExternalResponse } from 'core/services/api/payment/payment-pay-at-link';
import { RapydEmbeddedResponse } from 'core/services/api/payment/payment-rapyd';
import { CurrencyStore } from 'core/stores/currency.store';
import { PaymentRequestDirectLink } from './payment-request-direct-link';
import { PaymentRequestDPP } from './payment-request-dpp';
import { PaymentRequestMoment } from './payment-request-moment';
import { PaymentRequestMomentCheckout } from './payment-request-moment-checkout';
import { PayAtRedirectResolution, PayAtRedirectResponse, PaymentRequestPayAt } from './payment-request-pay-at';
import { PaymentRequestPayAtExternal } from './payment-request-pay-at-external';
import { PaymentRequestPSH } from './payment-request-psh';
import { EmbeddedIframeResponseResolution, PaymentRequestRapydEmbedded } from './payment-request-rapyd-embedded';
import { PaymentPlatform } from './payment.store';

export enum PaymentServiceDependency {
  Subscription = 'Subscription',
  Profile = 'Profile',
  Quotes = 'Quotes',
}

export interface PaymentRequestType<T extends PaymentRequestRedirectResponse | PayAtRedirectResponse[] | PayAtExternalResponse | PayAtRedirectResolution | RapydEmbeddedResponse> {
  addValues: (values: any) => void;
  toPaymentRequestObject: () => { [key: string]: any };
  toTokenRequestObject: () => { [key: string]: any };
  getDependantValues: () => Promise<PaymentRequestType<T>>;
  handleResponse: (response: T, paymentAttribution?: PaymentAttribution) => Promise<boolean> | Promise<PayAtRedirectResolution> | Promise<PayAtRedirectResolution | boolean> | Promise<EmbeddedIframeResponseResolution>;
}

export class GeneratePaymentRequest {
  request!: PaymentRequestType<any>;

  constructor(platform: PaymentPlatform, initialValues: Partial<MakePaymentPayloadDTO>, currencyStore: CurrencyStore) {
    const req = { ...initialValues };

    switch (platform) {
      case PaymentPlatform.DPP:
        this.request = new PaymentRequestDPP(req, currencyStore);
        break;
      case PaymentPlatform.RapydEmbedded:
        this.request = new PaymentRequestRapydEmbedded(req);
        break;
      case PaymentPlatform.RapydRedirect:
        this.request = new PaymentRequestPSH(req);
        break;
      case PaymentPlatform.PayAtExternal:
        this.request = new PaymentRequestPayAtExternal(req);
        break;
      case PaymentPlatform.PayAtRedirect:
        this.request = new PaymentRequestPayAt(req);
        break;
      case PaymentPlatform.PaymentRequestDirectLink:
        this.request = new PaymentRequestDirectLink(req);
        break;
      case PaymentPlatform.PaymentRequestMoment:
        this.request = new PaymentRequestMoment(req, currencyStore);
        break;
      case PaymentPlatform.PaymentRequestMomentCheckout:
        this.request = new PaymentRequestMomentCheckout(req);
        break;
    }
  }

  addValues(values: { [key: string]: number | string | undefined }) {
    return this.request.addValues(values);
  }

  buildRequest(tokenize?: boolean) {
    return this.request.getDependantValues()
      .then(request => {
        return tokenize ? request.toTokenRequestObject() : request.toPaymentRequestObject()
      })
  }

  toPaymentRequestObject() {
    return {
      ...this.request.toPaymentRequestObject()
    }
  }
}